import { getField, updateField } from "vuex-map-fields";
import API from "@/api";

const initialState = () => ({
  files: [],
  allFilesSize: 0,
  availableSpace: 0,
});

export const state = initialState();

export const getters = {
  getField,
};

export const actions = {
  async getFiles({ commit }) {
    let res = await API.axios.get("/bff/api/v1/directory");
    if (res.status === 200) {
      commit("updateField", { path: "files", value: res.data.nodeList });
      commit("updateField", { path: "allFilesSize", value: res.data.size });
      commit("updateField", {
        path: "availableSpace",
        value: res.data.availableSpace,
      });
      return res.data.nodeList;
    }
  },
  async deleteFile({ commit }, { fileName, location }) {
    let params = new URLSearchParams();
    params.append("fileName", fileName);
    params.append("location", location);
    return API.axios.delete("/bff/api/v1/directory", { params });
  },
  async uploadFile({ commit }, { file, location, onUploadProgress }) {
    let formData = new FormData();
    formData.append("file", file);
    const params = new URLSearchParams();
    params.append("location", location);
    return API.axios.post("/bff/api/v1/directory", formData, {
      onUploadProgress: onUploadProgress,
      params: params,
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async downloadFile({ commit }, { fileLocation, name }) {
    let response = await API.axios.get(fileLocation, {
      responseType: "blob",
    });
    if (response.status === 200) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      return { status: response.status, data: "Arquivo baixado com sucesso!" };
    } else {
      return { status: response.status, data: "Erro ao baixar o arquivo!" };
    }
  },

  async renameFile({ commit }, { newName, file }) {
    const oldLocation = file.location;
    let newFileLocation = file.location.split("/");
    newFileLocation.pop();
    newFileLocation.push(newName);
    newFileLocation = newFileLocation.join("/");

    let params = new URLSearchParams();
    params.append("newName", newFileLocation);
    params.append("location", oldLocation);
    return API.axios.put("/bff/api/v1/directory", null, {
      params,
      headers: { "Content-Type": "application/json" },
    });
  },

  async zipDirectory({ commit }, { folderPath }) {
    const params = new URLSearchParams();
    params.append("folderPath", folderPath);

    return API.axios.post("/bff/api/v1/directory/zip", null, {
      params,
      headers: { "Content-Type": "application/json" },
    });
  },

  async createFolder({ commit }, folderPath) {
    const params = new URLSearchParams();
    params.append("folderPath", folderPath);
    return API.axios.post("/bff/api/v1/directory/create", null, {
      params: params,
    });
  },

  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
